var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, width: "40%", offset: 0 },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("inquiryInfo", { attrs: { item: _vm.item, "right-show": false } }),
          !_vm.isOrder
            ? _c(
                "div",
                { staticStyle: { "text-align": "center" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.sendInquiry },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.item.isSend == 1 ? "撤回" : "发送给客户")
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }